/**
 * Parsea una expression `string`, path de objeto y devuelve un array con todas las claves.
 *
 * @example CAB => ['CAB']
 * @example CAB.LIN => ['CAB', 'LIN']
 * @example CAB.LIN[0] => ['CAB', 'LIN', '0'] (--> nota que con joinArrayIndex -> ['CAB', 'LIN[0]'])
 * @example CAB.LIN[0].IMP => ['CAB', 'LIN', '0', 'IMP']
 * @example CAB['LIN'] => ['CAB', "['LIN']"]
 * @example CAB[Symbol('test')][0]['LIN'] => ['CAB', "[Symbol('test')]", '[0]', "['LIN']"]
 * @example CAB[Symbol('test')]['LIN'] => ['CAB', "[Symbol('test')]", "['LIN']"]
 * @example CAB[Symbol.for('test')][0]['LIN'] => ['CAB', "[Symbol.for('test')]", '[0]', "['LIN']"]
 * @example CAB[Symbol.for('test')]['LIN'] => ['CAB', "[Symbol.for('test')]", "['LIN']"]
 * @example CAB[Symbol.for('test')]['LIN'].REFERENCIA => ['CAB', "[Symbol.for('test')]", "['LIN']", 'REFERENCIA']
 * @example CAB[Symbol.for('test')]['LIN'][REFERENCIA] =>  (4) ['CAB', "[Symbol.for('test')]", "['LIN']", '[REFERENCIA]']
 *
 *
 * @param {string} expression
 * @returns {string[]}
 */
export function tokenizer(expression, { quotes = false } = {}) {
  if (typeof expression !== 'string') {
    throw new TypeError(`expression must be of type string`);
  }

  const res = [];
  const stack = [];
  let cur = '';
  explore(expression);
  return res;

  function explore(str, pos = 0) {
    if (pos > str.length - 1) {
      add(cur);
      return;
    }
    const char = str[pos];

    if (char === '"' || char === "'" || char === '`') {
      // forward
      if (quotes) {
        cur += char;
      }

      pos++;
      while (pos < str.length && str[pos] !== char) {
        cur += str[pos];
        pos++;
      }

      if (quotes && str[pos] === char) {
        cur += str[pos];
      }

      explore(str, pos + 1);
    } else if (char === '.' && stack.length === 0) {
      add(cur);
      explore(str, pos + 1);
    } else if (char === '[') {
      stack.push(']');
      add(cur);
      explore(str, pos + 1);
    } else if (char === ']') {
      const expected = stack.pop();
      if (expected !== ']') {
        throw new Error('mal formated, missing "]"');
      }
      add(cur);
      explore(str, pos + 1);
    } else {
      cur += char;
      explore(str, pos + 1);
    }
  }

  function add(exp) {
    if (!exp) {
      return;
    }

    if (exp.startsWith('Symbol')) {
      if (!exp.startsWith('Symbol.for')) {
        throw new Error(`No se puede ni tiene sentido copiar "Symbol" tal cual, solo "Symbol.for"`);
      }
      let key = exp.replace('Symbol.for', '').slice(1, -1); // 'Symbol.for(foo)' -> 'foo'
      if (quotes) {
        // 'Symbol.for("foo")' -> '"foo"'
        key = key.slice(1, -1); //  '"foo"' -> 'foo'
      }
      res.push(Symbol.for(key));
    } else {
      res.push(exp);
    }
    cur = '';
  }
}
